<div [id]="fullscreenBox" class="d-flex fullscreen-preview bg-white" [ngStyle]="{ height: height }">
  <div
    class="card sidebar mb-0"
    [class.start-sidebar-hidden]="collapseByDefault"
    [id]="'sidebar' + mapId"
    [ngStyle]="{ height: height }"
    *ngIf="editable || mapForm?.get('dataLayers')?.value?.length"
  >
    <maplix-map-sidebar
      *ngIf="mapForm"
      [mapForm]="mapForm"
      [mapType]="mapType"
      [wmsLegends]="WMSLegendUrls"
      [language]="language?.code"
      [editable]="editable"
      [sidebarTitle]="sidebarTitle"
      [activeTab]="sidebarActiveTab"
      [activeMap]="activeMap"
      (toggleHidden)="onChangeHidden($event)"
      (onDelete)="onDeleteLayer($event)"
      (toggleVisibility)="onChangeVisibility($event)"
      (open)="onOpenModal($event)"
      (openCloud)="onOpenCloudModal()"
      (changeLayerOrder)="onChangeLayerOrder()"
      (close)="changeSidebarVisibility(false)"
      (setBaseLayer)="onChangeBaseLayer($event)"
      (copyToClipboard)="onCopyUrlToClipboard($event)"
    >
    </maplix-map-sidebar>
  </div>

  <div [id]="mapId" class="analytics-map" [class.no-base-toggle]="!showBaseToggle">
    <div [id]="mapId + '-mapbox-bg'" class="mapbox-bg"></div>

    <div class="loader-overlay d-flex flex-column align-items-center justify-content-center" *ngIf="loading">
      <div class="spinner-grow avatar-sm text-white" role="status"></div>
      <div class="h4 mt-3 text-white">Loading</div>
    </div>

    <maplix-sidebar-toggle
      [showText]="sidebarTitle"
      [showSidebox]="showSidebar"
      (sideboxChange)="changeSidebarVisibility(true)"
      [icon]="'fe-layers'"
      [position]="'LEFT'"
      *ngIf="showSidebarToggle && editable"
    ></maplix-sidebar-toggle>

    <maplix-address-search
      [map]="map?.map"
      *ngIf="mapType === 'MAP' && showAddressSearch"
      [placeholder]="searchPlaceholder"
      [language]="language?.code"
    >
    </maplix-address-search>

    <maplix-baselayer-toggle
      [loading]="loading"
      *ngIf="mapType === 'MAP' && showBaseToggle"
      [maxHeight]="maxBaseToggleHeight"
      [activeLayer]="mapForm?.get('baseLayer').value"
      (activeLayerChange)="onChangeBaseLayer($event)"
      [tooltipText]="editable ? null : ('map.CHANGEBASELAYER' | translate)"
    >
    </maplix-baselayer-toggle>

    <maplix-map-attribution *ngIf="!editable && showAttribution" [app]="app"></maplix-map-attribution>

    <div class="mobile-toggle-overlay" *ngIf="showSidebar" (click)="changeSidebarVisibility(false)"></div>

    <ng-content></ng-content>
  </div>
</div>

<div style="visibility: hidden; position: absolute; top: 0; left: 0">
  <maplix-map-popup [popupInfo]="popupInfo" [mapId]="mapId"></maplix-map-popup>
</div>
